<template>
  <svg
    width="26"
    height="30"
    viewBox="0 0 26 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.2348 0.160843L4.87775 0.160843V10.3216C2.20955 12.1951 0.465607 15.2957 0.465607 18.8036L0.465607 29.1607H10.8227C16.4767 29.1607 21.0726 24.6301 21.1779 19.0013C23.8471 17.1278 25.5919 14.0266 25.5919 10.5179C25.5919 4.79786 20.9549 0.160843 15.2348 0.160843ZM21.1779 19.0013C21.1791 18.9355 21.1797 18.8696 21.1797 18.8036C21.1797 13.0836 16.5427 8.44654 10.8227 8.44654C8.61053 8.44654 6.56036 9.14007 4.87775 10.3216V10.5179C4.87775 16.238 9.51476 20.875 15.2348 20.875C17.4462 20.875 19.4956 20.182 21.1779 19.0013Z"
      fill="url(#paint0_linear)"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="-24.8233"
        y1="14.7026"
        x2="28.9156"
        y2="14.7026"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#979797" />
        <stop offset="1" stop-color="#979797" stop-opacity="0" />
      </linearGradient>
    </defs>
  </svg>
</template>
